import { mergeClasses } from '@fluentui/react-components';

import { useCardBackgroundContentStyles } from './CardBackgroundContent.styles';

interface CardBackgroundContentProps {
  headline: string
  body: string
  className?: string
}

const CardBackgroundContent: React.FC<CardBackgroundContentProps> = ({ headline, body, className }) => {
  const styles = useCardBackgroundContentStyles();
  const container = mergeClasses('card-background-content', styles.content, className);

  return (
    <div className={container} data-testid="card-background-content">
      <span className={styles.headline} data-testid="card-headline">{headline}</span>
      <span className={styles.body} data-testid="card-body">{body}</span>
    </div>
  );
};

export default CardBackgroundContent;
